"use strict";

Shopify.theme.jsTextSlider = {
  init: function init($section) {
    // Add settings from schema to current object
    let _self = this;
    Shopify.theme.jsTextSlider = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    ); // Selectors
    var $slideshow = $section.find("[data-slider]").removeClass("is-hidden");
    var $slider = $slideshow.flickity({
      wrapAround: true,
      freeScroll: true,
      cellAlign: "center",
      prevNextButtons: false,
      pageDots: false,
    });
    let slider = $slider.data("flickity");
    slider.x = 0;
    let requestId = false;
    play();

    setTimeout(function () {
      $slider.flickity("resize");
    }, 500);

    $slider.on("dragMove.flickity", function (event, pointer) {
      let $cursor = $(".cursor");
      if (!$cursor.length) {
        $slider.off("dragMove.flickity");
        return;
      }
      $cursor.css({
        top: event.clientY - $cursor.height() / 2,
        left: event.clientX - $cursor.width() / 2,
      });
    });

    function play() {
      slider.x -= _self.speed;
      slider.settle(slider.x);
      requestId = window.requestAnimationFrame(play);
    }

    function pause() {
      if (requestId) {
        window.cancelAnimationFrame(requestId);
        requestId = undefined;
      }
    }
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find("[data-slider]");
    var $sliderIndex = $("#shopify-section-" + blockId).data("slide-index");
    $slider.flickity("select", $sliderIndex, true, true);
  },
  unload: function unload($section) {},
};
